// extracted by mini-css-extract-plugin
export default {"container":"style_container__UL-U5","camera":"style_camera__wr3fJ","focus-video":"style_focus-video__kxlql"};